import { ACTION } from "src/util/utils";
import {
  INVENTORY_FINAL_UPDATE_IMPORT_FILE,
  INVENTORY_FINAL_UPDATE_IMPORT_FILE_FAILED,
  INVENTORY_FINAL_UPDATE_IMPORT_FILE_SUCCESS,
  KEYS,
  MODULE_KEY,
  INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT,
  INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT_FAILED,
  INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT_SUCCESS,
  INVENTORY_FINAL_UPDATE_CLEAN_IMPORT_LAYOUT,
} from "./actions";

export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY];

export interface IInventoryFinalUpdateState {
  loading: boolean;
  error: any;
  data: [];
  importLoading: boolean;
  importFailed: boolean;
  importValidationData: any[];
}

const defaultState: IInventoryFinalUpdateState = {
  loading: false,
  error: null,
  data: [],
  importLoading: false,
  importFailed: false,
  importValidationData: [],
};

export const InventoryFinalUpdateReducer = (
  state = defaultState,
  { type, payload }: any
) => {
  switch (type) {
    case KEYS[MODULE_KEY + ACTION.FETCH]:
      return {
        ...state,
        loading: true,
      };

    case KEYS[MODULE_KEY + ACTION.SUCCESS]:
      return {
        ...state,
        loading: false,
        data: [...payload],
      };
    case KEYS[MODULE_KEY + ACTION.FAILED]:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case INVENTORY_FINAL_UPDATE_IMPORT_FILE: {
      return {
        ...state,
        importLoading: true,
      };
    }
    case INVENTORY_FINAL_UPDATE_IMPORT_FILE_SUCCESS: {
      return {
        ...state,
        importLoading: false,
        importFailed: false,
        importValidationData: payload,
      };
    }
    case INVENTORY_FINAL_UPDATE_IMPORT_FILE_FAILED: {
      return {
        ...state,
        importLoading: false,
        importFailed: true,
        importValidationData: payload,
      };
    }
    case INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT: {
      return {
        ...state,
        importLoading: true,
      };
    }
    case INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT_SUCCESS:
    case INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT_FAILED: {
      return {
        ...state,
        importLoading: false,
      };
    }
    case INVENTORY_FINAL_UPDATE_CLEAN_IMPORT_LAYOUT: {
      return {
        ...state,
        importLoading: false,
        importFailed: false,
        importValidationData: [],
      };
    }

    default:
      return state;
  }
};
